export default ['40em', '52em', '64em'];